import React, { useMemo, useState } from "react";
import { NavLink } from "react-router-dom";
import ItemRecords from "./ItemRecords";
import StockRecords from "./StockRecords";
import { ITEM_TYPES } from "../constants";

const TABS = [
  { id: "buy", label: "Buy", to: "/buy" },
  { id: "sell", label: "Sell", to: "/sell" },
  { id: "stock", label: "Stock", to: "/stock" },
];

function HomePage({ view }) {
  const [previousFilter, setPreviousFilter] = useState({ text: "", year: "" });

  const body = useMemo(() => {
    if (view === "buy") {
      return (
        <ItemRecords
          type={ITEM_TYPES.Buy}
          previousFilter={previousFilter}
          onFilterChange={setPreviousFilter}
        />
      );
    }
    if (view === "sell") {
      return (
        <ItemRecords
          type={ITEM_TYPES.Sell}
          previousFilter={previousFilter}
          onFilterChange={setPreviousFilter}
        />
      );
    }
    return (
      <StockRecords
        previousFilter={previousFilter}
        onFilterChange={setPreviousFilter}
      />
    );
  }, [view, previousFilter]);

  return (
    <div className="home-layout">
      <div className="side-tabs">
        {TABS.map((tab) => (
          <NavLink
            key={tab.id}
            className={({ isActive }) =>
              isActive ? "tab-btn active" : "tab-btn"
            }
            to={tab.to}
          >
            {tab.label}
          </NavLink>
        ))}
      </div>
      <div className="content-panel">{body}</div>
    </div>
  );
}

export default HomePage;
